import { useEffect, useState } from 'react'
import Sheet from './Sheet'
import { attachMotionRiskHost, settleMotionRisk, type PendingRisk } from './motionRiskPrompt'

/** Окно «Kling, скорее всего, откажет — всё равно создать?» перед запуском Kling Motion Control (калибровка 12.10,
 *  pages/generate/hooks/useMotionPrecheck). Хост один на сайт (App); запуск ждёт ответа промисом confirmMotionRisk. */
export default function MotionRiskConfirmHost() {
	const [pending, setPending] = useState<PendingRisk | null>(null)

	useEffect(() => attachMotionRiskHost(setPending), [])

	return (
		<Sheet
			open={!!pending}
			onClose={() => settleMotionRisk(false)}
			variant="center"
			className="refusal-sheet motion-risk-sheet"
			contentClassName="refusal-sheet__content"
		>
			{pending && (
				<div className="nsfw-modal refusal-modal motion-risk-modal" role="alertdialog" aria-labelledby="motion-risk-title">
					<svg className="refusal-modal__icon motion-risk-modal__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
						strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
						<path d="M10.3 3.9 1.8 18.6A2 2 0 0 0 3.5 21.6h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
						<path d="M12 9v4.5" />
						<path d="M12 17.5h.01" />
					</svg>
					<h3 className="nsfw-modal-title" id="motion-risk-title">Kling, скорее всего, откажет</h3>
					<p className="nsfw-modal-body">{pending.text}</p>
					<p className="nsfw-modal-warning">Ответ Kling придёт только через несколько минут. Можно заменить ролик сейчас.</p>
					<div className="motion-risk-modal__actions">
						<button className="nsfw-modal-btn" type="button" onClick={() => settleMotionRisk(false)}>
							Заменить ролик
						</button>
						<button className="motion-risk-modal__go" type="button" onClick={() => settleMotionRisk(true)}>
							Всё равно создать
						</button>
					</div>
				</div>
			)}
		</Sheet>
	)
}
